import React, {type ReactNode} from 'react';
import styled from 'styled-components';

import {createStack, Stack} from '@famly/mf_layout_stack';

import type * as Types from '../types';
import {CollapsibleContainer} from '../components/collapsible-container';

const StackWithoutScrollbar = styled(
    createStack({
        direction: 'column',
        spacing: 8,
        p: 10,
        backgroundColor: 'n0',
        overflow: 'auto',
    }),
)`
    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */

    scrollbar-width: none; /* Firefox */
`;

type Props = {
    type: Types.Plan['type'];
    tuitionSelect: ReactNode;
    pricingGroupSelect: ReactNode;
    pricingGroupSelectPlacement: Types.PricingGroupSelectPlacement;
    discountSelect: ReactNode;
    feeSelect: ReactNode;
    billingFrequencySelect: ReactNode;
    planStartAndEndDateBanner: ReactNode;
    fallbackButtonToLegacyPlanEditor: {
        placement: 'inside-more-options' | 'outside-more-options';
        component: ReactNode;
    };
    unsupportedPlanNotice: ReactNode;
};

export const FormContent = (props: Props) => {
    const [showMoreOptions, setShowMoreOptions] = React.useState(false);
    return (
        <StackWithoutScrollbar data-e2e-id="edit-billing-plan-form-content">
            {props.type === 'unsupported-plan' ? (
                props.unsupportedPlanNotice
            ) : (
                <>
                    {props.planStartAndEndDateBanner}
                    {props.pricingGroupSelectPlacement === 'outside-more-options' ? props.pricingGroupSelect : null}
                    {props.tuitionSelect}
                    {props.discountSelect}
                    <CollapsibleContainer isOpen={showMoreOptions} onToggle={() => setShowMoreOptions(prev => !prev)}>
                        {props.feeSelect}
                        {props.pricingGroupSelectPlacement === 'inside-more-options' ? props.pricingGroupSelect : null}
                        {props.billingFrequencySelect}
                        {props.fallbackButtonToLegacyPlanEditor.placement === 'inside-more-options'
                            ? props.fallbackButtonToLegacyPlanEditor.component
                            : null}
                    </CollapsibleContainer>
                    <Stack direction="column" justifyContent="flex-end" height="100%">
                        {props.fallbackButtonToLegacyPlanEditor.placement === 'outside-more-options'
                            ? props.fallbackButtonToLegacyPlanEditor.component
                            : null}
                    </Stack>
                </>
            )}
        </StackWithoutScrollbar>
    );
};
